import { useState } from 'react';

import { Button, IconButton, IconButtonProps, Tooltip } from "@material-ui/core";
import LockOpenIcon from '@material-ui/icons/LockOpen';

import { DialogWithActions } from '..';
import { Apartment } from "../../../graphql/models";
import { useSnackbarMutation } from '../../../hooks';
import { MUTATIONS } from '../../../graphql';

export type UnlockApartmentReservationBlockButtonProps = IconButtonProps & {
  apartment: Apartment;
  onUnlocked?: () => void;
};

export function UnlockApartmentReservationBlockButton(props: UnlockApartmentReservationBlockButtonProps) {
  const { apartment, onUnlocked, ...iconButtonProps } = props;
  const [invokeResetApartmentConductStatus, { loading }] = useSnackbarMutation(
    MUTATIONS.RESET_APARTMENT_CONDUCT_STATUS, {
      onCompleted: () => {
        setOpen(false);
        onUnlocked && onUnlocked();
      }
    }
  );

  const [open, setOpen] = useState(false);

  const triggerResetStatus = () => {
    invokeResetApartmentConductStatus({
      variables: {
        apartmentId: apartment.id
      }
    });
  };

  const triggerUndo = () => {
    setOpen(false);
  }

  return (
    <>
      <Tooltip title='Rimuovi blocco prenotazioni appartamento'>
        <IconButton 
          {...iconButtonProps}
          onClick={() => setOpen(true)}
          aria-label="edit" 
          size="medium"
          disabled={loading}
        >
          <LockOpenIcon color='error' fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <DialogWithActions 
        open={open} 
        setOpen={setOpen}
        title={`Slocco appartamento ${apartment?.code}`}
        fullScreen={false}
        actions={[
          <Button disabled={loading} onClick={triggerUndo} color='primary'>Annulla</Button>,
          <Button disabled={loading} onClick={triggerResetStatus} color='secondary'>Confermo</Button>
        ]}
      >
        Confermi di voler sbloccare le prenotazioni per l'appartamento {apartment.code}?
      </DialogWithActions>
    </>
  );
}